var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.328 6.768 1.22-1.22a3.254 3.254 0 0 0 0-4.597 3.228 3.228 0 0 0-2.298-.95c-.87 0-1.685.338-2.299.951l-1.219 1.22 4.596 4.596Zm-5.656-3.536-9.035 9.034c-.193.193-.339.43-.424.688l-1.675 5.06a.75.75 0 0 0 .948.948l5.059-1.675c.258-.085.496-.232.689-.425l9.034-9.034-4.597-4.596Z",
    fill: "gray"
  })));
};

export default SvgEdit;